import ChipRounded from './ChipRounded';
import './style/CellPreview.css';
import React from 'react';
import { Text } from '@harperai/materialize-design-system';

const CellPreview = ({ rowNumber, columnName, value, message, first = true, last = true, primary = false, blurFadeDirection = null }) => {
    return (
        <div key={`${columnName}${value}${rowNumber}${message}`} className={`keystone-cell-preview  ${primary && 'primary'} product-horizontal-container align-start flex-1`}>
            <div className={`product-vertical-container align-center flex-1 relative height-100`}>
                <div className={`cell-preview-column-name-wrapper pad-xxs ${last ? 'last' : ''} ${first ? 'first' : ''}`}>
                    <Text size="micro" bold={true} variant="secondary" mono={true}>{columnName}</Text>
                </div>
                <div className={`cell-preview-value-wrapper height-100 center-text pad-xxs ${primary && 'primary'} relative ${blurFadeDirection && ('blur-' + blurFadeDirection)} width-100 pad-xs ${last && 'last'} ${first ? 'first' : ''}`}>
                    {value && (
                        <Text size="caption" bold={true} classes="center-text" mono={true}>{value}</Text>
                    )}
                </div>
                {message && (
                    <ChipRounded label={message.includes("MISSING_REQUIRED_FIELD") ? "Missing Value" :
                        message.includes("INVALID_QUANTITY") || message.includes("INVALID_UNIT_COST") || message.includes("INVALID_MINIMUM_PRICE") ? "Invalid Number" : message} negative={true} />
                )}
            </div>
        </div>
    );
};

export default React.memo(CellPreview);